// Données structurées schema.org générées depuis le planning du Google Sheet.
// Le bloc DanceSchool / LocalBusiness global vit dans public/index.html ; ici on
// produit les objets propres aux pages : Course + CourseInstance et Offer.
import { sessionPrice } from "./pricing";
import { courseSlug } from "./planningHelpers";

const SITE = "https://1000arts.ch";

const JOUR_EN = {
  Lundi: "https://schema.org/Monday",
  Mardi: "https://schema.org/Tuesday",
  Mercredi: "https://schema.org/Wednesday",
  Jeudi: "https://schema.org/Thursday",
  Vendredi: "https://schema.org/Friday",
  Samedi: "https://schema.org/Saturday",
  Dimanche: "https://schema.org/Sunday",
};

const ECOLE = {
  "@type": "DanceSchool",
  name: "1000 ARTS",
  url: `${SITE}/`,
  telephone: "+41 79 950 40 31",
  email: "info1000arts@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Chemin des Dailles 10E",
    addressLocality: "Cugy",
    addressRegion: "VD",
    postalCode: "1053",
    addressCountry: "CH",
  },
};

const hhmm = (t) => (/^\d{1,2}:\d{2}$/.test(String(t || "")) ? String(t) : undefined);

// Un objet Course par séance du planning, avec son CourseInstance (jour, horaire,
// salle, professeur). Les places restantes sont volontairement exclues : elles
// changent trop vite pour être publiées dans des données structurées.
export function courseSchema(session) {
  const slug = courseSlug(session);
  const start = hhmm(session.start);
  const end = hhmm(session.end);
  const jour = JOUR_EN[session.day];
  const profs = (session.teachers || []).filter(Boolean);

  return {
    "@context": "https://schema.org",
    "@type": "Course",
    name: session.name,
    description: [
      session.discipline,
      session.age_label ? `pour ${session.age_label}` : null,
      session.level ? `niveau ${session.level}` : null,
      "à 1000 ARTS, Cugy VD.",
    ]
      .filter(Boolean)
      .join(" · "),
    url: slug ? `${SITE}/cours/${slug}` : `${SITE}/planning`,
    inLanguage: "fr-CH",
    courseMode: "Onsite",
    educationalLevel: session.level || undefined,
    typicalAgeRange: session.age_label || undefined,
    about: session.discipline || undefined,
    provider: ECOLE,
    // Prix « à partir de » : le barème enfants & ados est le plancher ; le tarif adulte
    // (+60) dépend de la personne inscrite, pas du cours. Absent si la durée du cours
    // n'est pas tarifée (anomalie de planning signalée à l'école).
    offers: sessionPrice(session) ? {
      "@type": "Offer",
      price: sessionPrice(session),
      priceCurrency: "CHF",
      category: "Semestre",
      url: `${SITE}/inscription`,
      availability: "https://schema.org/InStock",
    } : undefined,
    hasCourseInstance: {
      "@type": "CourseInstance",
      courseMode: "Onsite",
      name: `${session.name} — ${session.day} ${session.start}`,
      courseSchedule: {
        "@type": "Schedule",
        repeatFrequency: "P1W",
        byDay: jour,
        startTime: start,
        endTime: end,
        scheduleTimezone: "Europe/Zurich",
      },
      location: {
        "@type": "Place",
        name: session.room ? `1000 ARTS — ${session.room}` : "1000 ARTS",
        address: ECOLE.address,
      },
      instructor: profs.map((p) => ({ "@type": "Person", name: p })),
    },
  };
}

export function coursesSchema(sessions) {
  return (sessions || []).map(courseSchema);
}

// Offres tarifaires de la page /tarifs.
export function offerSchema({ name, price, description, category }) {
  return {
    "@context": "https://schema.org",
    "@type": "Offer",
    name,
    description,
    price,
    priceCurrency: "CHF",
    category,
    url: `${SITE}/tarifs`,
    availability: "https://schema.org/InStock",
    seller: ECOLE,
    areaServed: { "@type": "AdministrativeArea", name: "Canton de Vaud" },
  };
}
